import ABOName from "../../../../../components/ABOProfile/ABOName/ABOName";
import { useAppSelector } from "../../../../../store";
import "./ABOProfileHeader.scss";
import { useGetABOProfileQuery } from "../../../../../services/AboProfile/AboProfileAPI";
import ProfileLoader from "../../../../../components/ABOProfile/ProfileLoader/ProfileLoader";
import { LeafErrorMessage } from "../../../../../common/leaf/LeafErrorMessage/LeafErrorMessage";
import LeafPinLevelName from "../../../../../common/leaf/LeafPinLevelName/LeafPinLevelName";
import { storedLocale } from "../../../../Authentication/util";
import { useTranslation } from "react-i18next";
import { getDisplayName } from "../../../../../common/util/displayName";
import defaultAwardLabelsContent from "../../../../../content/awardLabels";

const ABOProfileHeader = () => {
  // Get Login ABO
  const affAbo = useAppSelector((state) => state.profile.affAbo);
  const isFromEdLos = useAppSelector((state) => state.profile.isFromEdLos);
  const [aff = "", abo = ""] = affAbo.split("-");
  const { isFetching, isError, data } = useGetABOProfileQuery({
    aff,
    abo,
    ...(isFromEdLos ? { includePlatinumAndAbove: true } : {}),
  });
  const { t } = useTranslation(["common", "awardLabels"]);

  if (isFetching === false && data?.aboInfo && data?.awardInfo) {
    const { aboNo, name, localName, displayName, privacyFlag, isoLanguageCode } = data.aboInfo;

    const { currentPin } = data.awardInfo;

    return (
      <>
        <div className="abo-profile-header__abo-details">
          <div className="abo-profile-header__abo-name">
            {displayName ? (
              <span className="abo-name--large abo-name--bold">{getDisplayName(displayName, t)}</span>
            ) : (
              <ABOName
                name={name}
                localName={localName}
                privacyFlag={privacyFlag}
                languageCode={isoLanguageCode}
                fontSize="large"
                fontWeight="bold"
                locale={storedLocale()}
              />
            )}
          </div>
          <div className="abo-profile-header__abo-award-label">
            {data.isDiamondAndAbove ? (
              <span>
                {String(t("awardLabels.diamond-and-above", defaultAwardLabelsContent.awardLabels["diamond-and-above"]))}
              </span>
            ) : data.isEmeraldAndAbove ? (
              <span>
                {String(t("awardLabels.emerald-and-above", defaultAwardLabelsContent.awardLabels["emerald-and-above"]))}
              </span>
            ) : data.isPlatinumOrAbove ? (
              <span>
                {String(t("awardLabels.platinum-or-above", defaultAwardLabelsContent.awardLabels["platinum-or-above"]))}
              </span>
            ) : (
              <LeafPinLevelName pinLevelCode={currentPin} />
            )}
          </div>
          <div className="abo-profile-header__abo-number">
            <span className="abo-profile-header__abo-number">#{aboNo}</span>
          </div>
        </div>
      </>
    );
  }

  if (isError === true) {
    // TODO :: tealium tagging track event for error
  }

  return (
    <>
      <LeafErrorMessage show={isError} />
      <ProfileLoader row={1} isFetching={isFetching} />
    </>
  );
};

export default ABOProfileHeader;
